/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], (APIFactory, stringResources, ContentActionsProviderAPI) => {

	class DeveloperWidgetRefreshAction {

		constructor({ features }) {
			this.dashboard = features.API;
			this.features = features;
			features.ContentActions.registerProvider('developerWidgetRefreshAction', this.getAPI());
		}

		getAPI() {
			return APIFactory.createAPI(this, [ContentActionsProviderAPI]);
		}

		getContentActionList(idList) {
			const contentId = idList[0];
			const content = this.dashboard.getCanvas().getContent(contentId);
			const refreshIcon = this.features['Icons'].getIcon('refreshIcon');
			if (this._supportAction(idList, content)) {
				return [{
					name: 'developerWidgetRefreshAction',
					label:  stringResources.get('toolbarActionRefreshDeveloperWidget'),
					icon: refreshIcon.id,
					type: 'Button',
					section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_VIZ_FORMAT,
					order: 50,
					actions: {
						apply: this.refreshDeveloperWidget.bind(this, content)
					}
				}];
			}
			return [];
		}

		_supportAction(idList, content) {
			if (idList && idList.length != 1) {
				// does not support multi-widget selections (for now?)
				return false;
			}

			if (this.dashboard.getMode() !== this.dashboard.MODES.EDIT) {
				return false;
			}

			if (!this._isDeveloperWidget(content)) {
				return false;
			}

			if (!this._hasPermissions()) {
				return false;
			}

			return true;
		}

		_isDeveloperWidget(content) {
			const visualization = content.getFeature('Visualization');
			if (!visualization) {
				return false;
			}

			const definition = visualization.getDefinition();
			const isErrorState = !!definition.getState().getError();
			let id = definition.getId();
			if (isErrorState) {
				const error = content.getFeature('state').getError();
				const errorParams = error && error.getParams && error.getParams();
				id = errorParams && errorParams.errorInfo && errorParams.errorInfo.id;
			}
			return id === 'visualizationPreview';
		}

		_hasPermissions() {
			const userCapabilities = this.dashboard.getGlassCoreSvc('.UserProfile').capabilities;
			return userCapabilities.indexOf('canDevelopVisualizations') !== -1;
		}

		refreshDeveloperWidget(content) {
			content.getFeature('Visualization').getDefinition().refresh();
			this.dashboard.getFeature('UndoRedo').clearStack();
		}
	}

	return DeveloperWidgetRefreshAction;
});
